import React from 'react';
import { useTheme } from '../context/ThemeContext';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button 
      className="theme-toggle-btn" 
      onClick={toggleTheme}
      aria-label="Toggle theme"
    >
      <i className={`fa-regular fa-${theme === 'light' ? 'moon' : 'lightbulb'}`}></i>
    </button>
  );
};

export default ThemeToggle;
